import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/payslip-templates',
    name: 'payslip-template',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/payslip-template/index.vue')
  }
]
